<template>
  <div class="buy">
   <img :src="currentImageUrl" id='slide' v-if="currentImage" usemap="#learnMore" >
   <map id="learnMore" name="learnMore" v-if="screenImagesFolderName=='learn'">
      <area shape="rect"  coords="255,290,527,402" href="https://cx.sap.com/en/solutions/industries/retail/fashion" target="_blank" alt="FOR FASHION">
      <area shape="rect"  coords="528,290,800,402" href="https://cx.sap.com/en/products/digital-portfolio" target="_blank" alt="SAP C/4HANA ">
  </map>
  <div class="rectangle" @click="$parent.goToNextScreen()" 
    v-if="currentImage && currentImage.coordinates && currentImage.coordinates.left" 
    v-bind:style="highlightRectangleStyle"></div>
   <div class="next" v-if="currentImage && currentImage.hasNext">
    <div class="corner" @click="$parent.goToNextScreen()" v-if="currentImage && currentImage.hasNext"></div>
   </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
export default {
  props: {
    storyboardScreens: Array,
    screenId: String,
    screenImagesFolderName: String
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    //this.$store.commit("SHOW_ALLERT");
    if (localStorage) {
    }
    this.alreadyVisited = false;
    if (Cookies.get("sap-recurrent-visit") === "1") {
      this.alreadyVisited = true;
    }
    Cookies.set("sap-recurrent-visit", "1", { expires: 30 });
    if (!this.alreadyVisited) {
      this.$store.commit("IS_HELP_SHOWN");
    }
  },
  computed: {
    ...mapGetters(["chapters"]),
    currentImage() {
      if (this.storyboardScreens) {
        return this.storyboardScreens.find(a => a.screenId == this.screenId);
      }
    },
    highlightRectangleStyle() {
      let rectStyle = {};
      if (this.currentImage && this.currentImage.coordinates) {
        var coordinates = ["left", "top", "right", "bottom"];
        for (let coordinate of coordinates) {
          rectStyle[coordinate] =
            this.currentImage.coordinates[coordinate] + "px";
        }
      }
      return rectStyle;
    },

    currentImageUrl() {
      return require("../image/" +
        this.screenImagesFolderName +
        "/" +
        this.currentImage.imageFile);
    }
  },
  watch:{
    screenImagesFolderName(newValue){
      if(newValue=="learn"){
        this.$store.commit("HIDE_ALLERT");
      }
    }
  }
};
</script>
<style  lang="scss" scoped>
.next {
   height:280px;
    width:280px; 
    position: absolute;;
    overflow:hidden;
     bottom:0px;
    right:0px; 
}
.corner {
  display: block;
  position: absolute;
  height: 290px;
  width: 290px;
  bottom: -150px;
  right: -150px;
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  filter: progid:DXImageTransform.Microsoft.Matrix( 
        M11=0.7071067811865476, M12=-0.7071067811865475, M21=0.7071067811865475,  M22=0.7071067811865476, sizingMethod='auto expand');
  zoom: 1;
}

.ie .corner {
  top: -210px;
  right: -210px;
}

.corner:hover {
  background-color: #eaac29;
  opacity: 0.5;
  cursor: pointer;
}
@keyframes fadein {
  from {
    background-color: rgba(234, 172, 41, 0.0);
  }
  to {
    background-color: rgba(234, 172, 41, 0.47);
 
  }
}
.rectangle {
  position: absolute;
  // opacity: 0.47;
  cursor: pointer;
  box-sizing: border-box;
  border: 3px solid #eaac29;
  // background-color: #eaac29;
  background-color: rgba(234, 172, 41, 0.47);
  // transition: opacity 1.5s ease;
  //transition: opacity 5s ease-in-out;
  animation-name: fadein;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  // animation: fadein ease 5s;
}
.buy {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: stretch;
}
img {
  object-fit: contain;
  width: 100%;
}
</style>

